const ProModal = {
  init() {
    this.events();
    this.whatsappTool();
    // this.autopopout();
  },

  close() {
    if (!$('.spec-popup-box').hasClass('open')) {
      return;
    }

    $('.spec-popup-box').removeClass('open');
  },

  whatsappTool() {
    const $tool = $("[data-wa-tool]");
    if (!$tool.length) {
      return;
    }

    const open = () => {
      $tool.addClass("wa-tool--open");
      $tool.find("[data-wa-tool-open]").attr("aria-expanded", "true");
      $tool.find("[data-wa-tool-popup]").prop("hidden", false);
    };

    const close = () => {
      $tool.removeClass("wa-tool--open");
      $tool.find("[data-wa-tool-open]").attr("aria-expanded", "false");
      $tool.find("[data-wa-tool-popup]").prop("hidden", true);
    };

    $tool.on("click", "[data-wa-tool-open]", function (e) {
      e.preventDefault();
      open();
    });

    $tool.on("click", "[data-wa-tool-close]", function (e) {
      e.preventDefault();
      close();
    });

    $("body").on("keyup.waTool", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        close();
      }
    });

    $("body").on("click.waTool", function (e) {
      if (!$tool.hasClass("wa-tool--open")) {
        return;
      }
      if (!$tool.is(e.target) && $tool.has(e.target).length === 0) {
        close();
      }
    });
  },

  events() {
    // Spec popup
    $('.spec-popup-button').on('click', function () {
      $('.spec-popup-box').toggleClass('open');
    });
    $('.spec-popup-box__close').on('click', function () {
      ProModal.close();

      if (sessionStorage.getItem('pro-modal-auto')) {
        sessionStorage.setItem('pro-modal-seen', true);
      }
    });
    $('body').on('keyup', function (e) {
      if (e.keyCode === 27) {
        ProModal.close();
      }
    });
    $('body').on('click', function (e) {
      var container = $(".spec-popup");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        ProModal.close();
      }
    });
  },

  // autopopout() {
  //   const auto = sessionStorage.getItem('pro-modal-auto');
  //   const seen = sessionStorage.getItem('pro-modal-seen');

  //   if (seen) {
  //     return
  //   }

  //   if (auto) {
  //     $('.spec-popup-box').addClass('open');
  //     return;
  //   }

  //   if ($('body').hasClass('single-product') && $(window).width() > 900) {

  //     setTimeout(function () {
  //       sessionStorage.setItem('pro-modal-auto', true)
  //       $('.spec-popup-box').addClass('open');
  //     }, 3000);
  //   }
  // }
}
export default ProModal;
